import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { delay, finalize, map, of } from 'rxjs';
import { UserProfile } from '../models/userProfile';
import { settings } from '../shared/globals/settings';
import { AuthService } from '../shared/services/auth.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.less']
})
export class ProfileComponent implements OnInit {

	user!: UserProfile;
	logoutEndpoint: string = settings.endpoints.logout;
	processingLogout: boolean = false;
	processingEmailConfirmationLink: boolean = false;
	emailConfirmationLinkSent: boolean = false;

	constructor(
		private readonly _route: ActivatedRoute,
		private readonly _router: Router,
		private readonly _authService: AuthService
	) { }

	ngOnInit(): void {
		this._route.data.pipe(map((data: Data) => data['user'])).subscribe(v => {
			this.user = v as UserProfile;
		});
	}

	public get userFullName(): string {
		return this.user.firstName + ' ' + this.user.lastName;
	}

	public logout() {
		this.processingLogout = true;
		this._authService.logout()
			.pipe(
				finalize(() => {
					this.processingLogout = false;
				})
			)
			.subscribe({
				next: (v) => {
					this._router.navigate(['/']);
				}
			})
	}

	public sendEmailConfirmationLink() {
		this.processingEmailConfirmationLink = true;
		this._authService.generateEmailConfirmationLink()
			.pipe(
				finalize(() => {
					this.processingEmailConfirmationLink = false;
				})
			)
			.subscribe({
				next: (v) => {
					this.emailConfirmationLinkSent = true;
				}
			})
	}

}
